import { render, staticRenderFns } from "./BaseImageEditor.vue?vue&type=template&id=0f9236f9&scoped=true"
import script from "./BaseImageEditor.vue?vue&type=script&lang=js"
export * from "./BaseImageEditor.vue?vue&type=script&lang=js"
import style0 from "./BaseImageEditor.vue?vue&type=style&index=0&id=0f9236f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9236f9",
  null
  
)

export default component.exports